import { DISCIPLINES } from '../../core/contracts'
import type { AnyGameModule } from '../../core/contracts'
import { useT } from '../../platform/i18n/useT'
import type { TKey } from '../../platform/i18n/i18nContext'
import { gamesOf } from '../../registry'
import { gameHint, gameTitle } from '../gameText'
import './screens.css'

interface Props {
  onPlay: (game: AnyGameModule) => void
}



/** Free Play: все игры по дисциплинам. */
export function GamesScreen({ onPlay }: Props) {
  const { t } = useT()

  return (
    <>
      <header className="sc__head">
        <div className="sc__eyebrow">Free Play</div>
        <h1 className="sc__h1">{t('nav.games')}</h1>
        <p className="sc__lead">{t('games.sub')}</p>
      </header>

      {DISCIPLINES.map((d) => {
        const list = gamesOf(d)
        if (list.length === 0) return null
        return (
          <section key={d}>
            <div className="sc__label">{t(`discipline.${d}` as TKey)}</div>
            {list.map((game) => (
              <button key={game.id} className="sc__row" onClick={() => onPlay(game)}>
                <span className="sc__meta">
                  <b>{gameTitle(t, game)}</b>
                  <small>{gameHint(t, game)}</small>
                </span>
                <span className="sc__arrow">→</span>
              </button>
            ))}
          </section>
        )
      })}

    </>
  )
}
